import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class IpService {
  constructor(private http: HttpClient) { }

  getIpAddress(): Observable<string> {
    return this.http.get<{ip: string}>('https://api.ipify.org?format=json')
      .pipe(
        map(response => response.ip)
      );
  }
} 